import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgType = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "feather feather-type",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("polyline", { points: "4 7 4 4 20 4 20 7" }),
		/* @__PURE__ */ _jsx("line", {
			x1: 9,
			y1: 20,
			x2: 15,
			y2: 20
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 12,
			y1: 4,
			x2: 12,
			y2: 20
		})
	]
});
const ForwardRef = forwardRef(SvgType);
export { ForwardRef as ReactComponent };
